// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"style_majorContainer__3rcIh","form":"style_form__1YehW","link":"style_link__UBRj3","button":"style_button__fZt61"};